import { Navigate, useLocation, useOutletContext } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import { ReviewOverviewOutletContext } from 'modules/performance_process/pages/reviews/show/overview'

const buildRedirectPath = (
  navigation: ReturnType<typeof useNavigation>['navigation'],
  { reviewProcess, canOnlySeePersonalResults }: ReviewOverviewOutletContext
) => {
  if (reviewProcess.status === 'draft') {
    return navigation.performanceProcess.reviews.review.overview.draft
  }

  if (canOnlySeePersonalResults) {
    return navigation.performanceProcess.reviews.review.overview.personalResults
  }

  return navigation.performanceProcess.reviews.review.overview.insights
}

const ReviewOverviewRedirectPage = () => {
  const context = useOutletContext<ReviewOverviewOutletContext>()
  const { navigation } = useNavigation()
  const location = useLocation()

  const redirectPath = buildRedirectPath(navigation, context)

  return (
    <Navigate
      replace
      to={{
        pathname: redirectPath.fullPath({ reviewId: context.reviewProcess.id }),
        search: location.search,
      }}
    />
  )
}

export default ReviewOverviewRedirectPage
